import Modal from "react-bootstrap/Modal";
import { useSelector, useDispatch } from "react-redux";
import { tagsSelector } from "../../redux/modules/tags/selector";
import { Tag, RootState } from "../../redux/utils/types";
import { useState, useEffect } from "react";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { getTags } from "../../redux/modules/tags/actions";

export default function TagPrompt(props: {
 show: boolean;
 handleOk: any;
 handleCancel: any;
 selectedTags: Tag[];
}) {
 const { show, handleOk, handleCancel, selectedTags } = props;

 const dispatch = useDispatch<any>();
 const tagsMap = useSelector(tagsSelector);
 const tagsStatus = useSelector((state: RootState) => state.tags.status);
 const [tagsInput, setTagsInput] = useState<any>({});
 const animatedComponents = makeAnimated();

 // ViewCompany may have stale/partial data
 useEffect(() => {
   if (show) {
     dispatch(getTags());
   }
 }, [show, dispatch]);

 // Reset selections when modal closes
 useEffect(() => {
   if (!show) {
     setTagsInput({});
   }
 }, [show]);

 const allTags: Tag[] = Array.from(tagsMap.values());

 // NOT by id
 // companyTag.id is the join-table row ID, NOT the global Tag.id
 // So id-based comparison fails when editing an existing company.
 // tagName is consistent across both companyTag and Tag types.
 const selectedTagNames = new Set(selectedTags.map((t) => t.tagName));
 const availableTags = allTags.filter((t) => !selectedTagNames.has(t.tagName));

 const companyTags  = availableTags.filter((t) => t.tagType === "company");
 const productTags  = availableTags.filter((t) => t.tagType === "product");
 const solutionTags = availableTags.filter((t) => t.tagType === "solution");

 const toOptions = (tags: Tag[]) =>
   tags.map((t) => ({ label: t.tagName, value: t.id }));

 const handleChange = (key: string) => (selected: any) => {
   setTagsInput((prev: any) => ({
     ...prev,
     [key]: selected.map((s: any) => tagsMap.get(String(s.value))),
   }));
 };

 const handleAddTag = () => {
   handleOk(tagsInput);
   setTagsInput({});
 };

 const styles = {
   menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
   input: (provided: any) => ({
     ...provided,
     minHeight: "30px",
     gridArea: "2/1/1/2",
   }),
   placeholder: (provided: any) => ({ ...provided, gridArea: "1/1/2/3" }),
 };

 const isLoading = tagsStatus === "loading";

 return (
   <Modal show={show} size="lg" centered={true}>
     <div className="modal-content p-3">
       <div className="modal-body">
         <div className="delete-tag">
           <p>Are you sure you want to add this Tag to the company?</p>
           <div className="container-fluid">
             <div className="row d-flex select-category">
               <div className="col-12 form-group">
                 <Select
                   closeMenuOnSelect={false}
                   components={animatedComponents}
                   isMulti
                   isLoading={isLoading}
                   options={toOptions(companyTags)}
                   styles={styles}
                   menuPortalTarget={document.body}
                   placeholder="Select Company Type Tags"
                   onChange={handleChange("companyType")}
                 />
               </div>
               <div className="col-12 form-group">
                 <Select
                   closeMenuOnSelect={false}
                   components={animatedComponents}
                   isMulti
                   isLoading={isLoading}
                   options={toOptions(productTags)}
                   styles={styles}
                   menuPortalTarget={document.body}
                   placeholder="Select Product Type Tags"
                   onChange={handleChange("productType")}
                 />
               </div>
               <div className="col-12 form-group">
                 <Select
                   closeMenuOnSelect={false}
                   components={animatedComponents}
                   isMulti
                   isLoading={isLoading}
                   options={toOptions(solutionTags)}
                   styles={styles}
                   menuPortalTarget={document.body}
                   placeholder="Select Solution Type Tags"
                   onChange={handleChange("solutionType")}
                 />
               </div>
             </div>
           </div>
         </div>
       </div>
       <div className="modal-footer justify-content-center">
         <button className="btn back-btn" onClick={handleAddTag}>
           Yes
         </button>
         <button
           type="button"
           className="btn back-btn"
           data-dismiss="modal"
           onClick={handleCancel}
         >
           No
         </button>
       </div>
     </div>
   </Modal>
 );
}